const TTL_HISTORIC_SEARCH_ITEM = 60 * 60 * 24 * 7;
const HISTORIC_MAX_LENGTH = 6;
const LOCAL_STORAGE_HISTORIC = 'tree-view-search-historic';

const siteAccess = window.imaios.getSiteAccess();

const DEFAULT_EMPTY_HISTORIC = {};

export default {
    namespaced: true,
    state: {
        /**
         * the string key is the siteaccess
         * @type {Object.<string, Object[]>}
         */
        historic: DEFAULT_EMPTY_HISTORIC,
    },
    getters: {
        historicBySiteAccessAndTaId: state => ({ taId }) => {
            const historicItemsBySiteAccessAndTaId = state.historic[siteAccess]
                ?.filter(historicItem => historicItem.value.taId === taId) ?? [];

            const sortedHistoricItemsBySiteAccessAndTaId = historicItemsBySiteAccessAndTaId
                .sort((itemA, itemB) => itemB.visitTime - itemA.visitTime);

            return sortedHistoricItemsBySiteAccessAndTaId.map(item => item.value);
        },
        historicByApplication: state => ({ application }) => {
            return state.historic[siteAccess]?.filter(
                historicItem => historicItem.value.application === application
            ) ?? [];
        },
    },
    mutations: {
        initializeStore: (state) => {
            let localStorageHistoric;
            try {
                localStorageHistoric = localStorage.getItem(LOCAL_STORAGE_HISTORIC);
            } catch (e) {
                // localStorage unavailable, initialize store from it
            }

            if (localStorageHistoric) {
                let parsedLocalStorageHistoric;
                try {
                    parsedLocalStorageHistoric = JSON.parse(localStorageHistoric);
                } catch (e) {
                    if (e instanceof SyntaxError) {
                        // local storage historic has been corrupted and is not readable, reset it
                        localStorage.setItem(LOCAL_STORAGE_HISTORIC, JSON.stringify(DEFAULT_EMPTY_HISTORIC))
                        parsedLocalStorageHistoric = DEFAULT_EMPTY_HISTORIC;
                    } else {
                        throw e;
                    }
                }

                Object.keys(parsedLocalStorageHistoric).forEach(
                    siteAccess => parsedLocalStorageHistoric[siteAccess].filter(
                        historicItem => (historicItem.visitTime + TTL_HISTORIC_SEARCH_ITEM) >= (new Date()).getTime()
                    )
                );

                state.historic = parsedLocalStorageHistoric;
            }
        },
        addItemToHistoric: (state, { item: itemToAdd }) => {
            (state.historic[siteAccess] ??= []).push({
                value: itemToAdd,
                visitTime: (new Date()).getTime(),
            });
        },
        removeOldestItemByApplication: (state, { historicByApplication }) => {
            const sortedHistoricByApp = historicByApplication.sort((itemA, itemB) => itemA.visitTime - itemB.visitTime);

            state.historic[siteAccess] = (state.historic[siteAccess] ?? []).filter(
                item => item.value.hash !== sortedHistoricByApp[0].value.hash
            );
        },
        refreshItemInHistoric: (state, { itemIndex }) => {
            state.historic[siteAccess][itemIndex].visitTime = (new Date()).getTime();
        },
    },
    actions: {
        visitItem: {
            root: true,
            handler: ({ commit, state, getters }, { item: visitedItem }) => {
                const itemIndex = (state.historic[siteAccess] ?? []).findIndex((historicItem) => historicItem.value.hash === visitedItem.hash);

                if (itemIndex >= 0) {
                    commit('refreshItemInHistoric', { itemIndex });
                } else {
                    const historicByApplication = getters.historicByApplication({ application: visitedItem.application });

                    if (historicByApplication.length === HISTORIC_MAX_LENGTH) {
                        commit('removeOldestItemByApplication', { historicByApplication });
                    }

                    commit('addItemToHistoric', { item: visitedItem });
                }
            }
        }
    }
};

export const writeHistoricToLocaleStorage = (historic) => {
    try {
        localStorage.setItem(LOCAL_STORAGE_HISTORIC, JSON.stringify(historic));
    } catch (e) {
        // localStorage unavailable, won't store in it
    }
}
